module.exports = "/_next/static/videos/snowboarding-3-41f92ba7c8f52d7719e32a036aa640ba.webm";